import { MessageBox } from 'element-ui'

const SESSION_KEY = 'wd_session_expired'
let dialogVisible = false

export function isSessionExpired() {
  return sessionStorage.getItem(SESSION_KEY) === '1'
}

export function markSessionExpired() {
  sessionStorage.setItem(SESSION_KEY, '1')
}

export function clearSessionExpired() {
  sessionStorage.removeItem(SESSION_KEY)
}

function clearAuth() {
  localStorage.removeItem('wd_token')
  localStorage.removeItem('wd_user')
}

function isAuthEndpoint(url = '') {
  return /\/auth\/(login|register|refresh)/.test(url)
}

/**
 * 401 时弹出对话框：用户可重新登录或暂不登录（功能受限）。
 */
export async function handleUnauthorized(err) {
  const url = err?.config?.url || ''
  if (isAuthEndpoint(url)) return

  const store = (await import('@/store')).default
  const router = (await import('@/router')).default

  clearAuth()
  store.commit('CLEAR_AUTH')
  markSessionExpired()

  if (dialogVisible) return
  dialogVisible = true
  try {
    await MessageBox.confirm(
      '登录已过期，请重新登录后继续使用。您也可以选择暂不登录，但需登录的功能将不可用。',
      '登录过期',
      {
        confirmButtonText: '重新登录',
        cancelButtonText: '暂不登录',
        type: 'warning',
        closeOnClickModal: false,
        closeOnPressEscape: false,
        showClose: false
      }
    )
    clearSessionExpired()
    const redirect = router.currentRoute.fullPath
    if (redirect && redirect !== '/login') {
      router.push({ path: '/login', query: { redirect } })
    } else {
      router.push('/login')
    }
  } catch {
    const route = router.currentRoute
    if (route.meta.requiresAuth || route.meta.requiresAdmin) {
      router.replace('/')
    }
  } finally {
    dialogVisible = false
  }
}
